import { render } from "./ViewIcon.vue?vue&type=template&id=666986f6&scoped=true"
const script = {}

import "./ViewIcon.vue?vue&type=style&index=0&id=666986f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666986f6"]])

export default __exports__